// eslint-disable-next-line no-restricted-imports
import { Routes } from "react-router-dom"
import sentry from "src/services/sentry"

const SentryRoutes = sentry.withSentryRouting(Routes)

export { SentryRoutes as Routes }
